var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "tw-a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tw-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h720v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000095",
    d: "M0 0h360v240H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154 126.9-2.5 9.6 9.4 2.6-1.8-7.1zm46.9 5.1-1.8 7.1 9.4-2.6-2.5-9.6zm-41.8-24-5.1 5.1 1.9 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.9 120-1.9 6.9 5.1 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154 113.1-6.9 6.9 6.9 6.9 1.9-6.9zm14 27.8 5.1 5.1 6.9-1.9zm18.9 5.1 9.6 2.5 2.6-9.4-7.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 140.9 7.1-1.8 1.8-7.1zm-31.1-1.8 2.6 9.4 9.6-2.5-5.1-5.1zm19.1 5 6.9 1.9 5.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.1 146 6.9 6.9 6.9-6.9-6.9-1.9zm-12.2-45.1-9.4 2.6 2.5 9.6 5.1-5.1zm-1.8 31.1 1.8 7.1 7.1 1.8zm45-12 1.9-6.9-5.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 99.1-7.1 1.8-1.8 7.1zm32.9 8.9-1.8-7.1-7.1-1.8zm5.1 18.9 6.9-6.9-6.9-6.9-1.9 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.9 108-8.9-8.9-12-3.2-12 3.2-8.9 8.9-3.2 12 3.2 12 8.9 8.9 12 3.2 12-3.2 8.9-8.9 3.2-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.9 132 5.1-5.1-1.9-6.9zm5.1-18.9 2.5-9.6-9.4-2.6 1.8 7.1zm-6.9-12.2-2.6-9.4-9.6 2.5 5.1 5.1zm-26-6.9-9.6-2.5-2.6 9.4 7.1-1.8zm6.9 1.9-6.9-1.9-5.1 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.9 94-6.9-6.9-6.9 6.9 6.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 99.1-5.1-5.1-6.9 1.9zM173.1 146l-9.6 2.5 4.5 16.6 12-12.2zm-5.1 19.1 12 44.9 12-44.9-12-12.2zm-7.1-26-9.4-2.6-4.4 16.4 16.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.1 152.9-12 45.1 32.9-32.9-4.5-16.6zm-12-20.9L102 165.1l45.1-12.2 4.4-16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154 126.9-6.9-6.9-12 12 16.4 4.5zm0-13.8-2.5-9.6-16.4 4.5 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1 108 90 120l45.1 12 12-12zm90 24-16.6 4.5 4.4 16.4 45.1 12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.1 139.1-2.6 9.4 16.4 4.4-4.4-16.4zm-12.2 6.9-6.9 6.9 12 12.2 4.5-16.6zm19.1-19.1 2.5 9.6 16.6-4.5-12.2-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 165.1 33.1 32.9-12.2-45.1-16.4-4.4zm7.1-64.2 9.4 2.6 4.4-16.4-16.4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1 108 258 75.1l-45.1 12-4.4 16.4zm-12.2-20.9L225.1 42 192 75.1l4.5 16.4zm12.2 44.9 44.9-12-44.9-12-12.2 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 113.1 6.9 6.9 12.2-12-16.6-4.5zm-38-38L135.1 42l12 45.1 16.4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.9 100.9 2.6-9.4-16.4-4.4 4.4 16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.1 87.1-45.1-12 33.1 32.9 16.4-4.5zm39.8 6.9 9.6-2.5-4.5-16.4-12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 75.1 180 30l-12 45.1 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.1 94 6.9-6.9-12-12-4.5 16.4z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 120,
    r: 51.1,
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 120,
    r: 45.1,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.39308d8769d9190bd1aaa8ff1a6a5f88.svg";
export { ForwardRef as ReactComponent };